import Checkbox from '../../../components/Form/Checkbox/Checkbox';
import { Updater } from '../../../hooks/useImmer';
import { useTranslation } from '../../../i18n/i18n';
import { ApiSchedule } from '../../../types';
import { DaysOrderKey, parseWeeklyDays, sortDays, stringifyWeeklyDays } from '../utils';

interface WeekPatternFormProps {
	schedule: ApiSchedule;
	setSchedule: Updater<ApiSchedule>;
}

export const WeekPatternForm = ({ schedule, setSchedule }: WeekPatternFormProps): JSX.Element => {
	const t = useTranslation().subscriptions;

	const addWeekDay = (id: DaysOrderKey, draft: ApiSchedule): DaysOrderKey[] =>
		parseWeeklyDays(draft.weeklyDays).concat([id]).sort(sortDays);

	const removeWeekDay = (id: number, draft: ApiSchedule): DaysOrderKey[] =>
		parseWeeklyDays(draft.weeklyDays)
			.filter((r) => r !== id)
			.sort(sortDays);

	const onWeekdayChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		const id = parseInt(e.target.id) as DaysOrderKey;

		setSchedule((draft) => {
			if (e.target.checked) {
				draft.weeklyDays = stringifyWeeklyDays(addWeekDay(id, draft));
			} else {
				draft.weeklyDays = stringifyWeeklyDays(removeWeekDay(id, draft));
			}
		});
	};

	return (
		<>
			<p>{t.schedule.repeatOn}</p>
			<div className="checkbox-grid">
				{Object.values(t.schedule.weekdays)
					.sort((a, b) => (a.id === 0 ? 7 : a.id - b.id))
					.map(({ id, text }) => (
						<Checkbox
							key={id}
							id={id + ''}
							checked={parseWeeklyDays(schedule.weeklyDays)?.includes(id as DaysOrderKey)}
							label={text}
							onChange={onWeekdayChange}
						/>
					))}
			</div>
		</>
	);
};
